import {InsideDrawerApplication} from '../inside-drawer.application';

export class HelpCentreApplication extends InsideDrawerApplication {
    protected _isAnonymousModeAllowed(): boolean {
        return true;
    }
}


